import AgInvoiceSearch from '@/pages/invoiceManage/agInvoiceSearch'
import AgInvoiceDetail from '@/pages/invoiceManage/agInvoiceSearch/InvoiceDetail'
import AgInvoiceDetailOrderDetail from '@/pages/orderManage/agOrderList/OrderDetail'

export default [
  {
    path: '/agInvoiceSearch',
    name: 'AgInvoiceSearch',
    component: AgInvoiceSearch,
    props: true,
    meta: { name: '发票查询' }
  },
  {
    path: '/agInvoiceSearch/agInvoiceDetail/:orderId',
    name: 'AgInvoiceDetail',
    component: AgInvoiceDetail,
    meta: { name: ['发票查询', '发票详情'] }
  },
  {
    path: '/agInvoiceSearch/agInvoiceDetail/orderDetail/:orderId',
    name: 'AgInvoiceDetailOrderDetail',
    component: AgInvoiceDetailOrderDetail,
    props: true,
    meta: { name: ['发票查询', '发票详情', '订单详情'] }
  }
]



// WEBPACK FOOTER //
// ./src/router/invoiceManage/agInvoiceSearch.js